import { isAllQuarters } from '@/api/hcp/partnerscore/utils';
import { PartnerScoreDataAvailabilityTickIcon } from '@/components/base/Icons/PartnerScoreDataAvailabilityTickIcon';
import LoadingSpinner from '@/storybook/components/LoadingSpinner/LoadingSpinner';
import cx from 'classnames';
import React from 'react';
import { ScoreData } from '../../PartnerScoreDataAvailabilityTypes/PartnerScoreDataAvailabilitytypes';
import styles from './TableData.module.css';
export interface Quarter {
  year: number;
  quarters: number[];
}

interface TableDataProps {
  country: { value: string; label: string };
  index: number;
  filteredPartnerScore: ScoreData[];
  allYearQuarters: Quarter[];
  selectedCountries: string[];
  selectedYear: number;
  selectedQuarter: number;
  isLoading: boolean;
}

const TableData: React.FC<TableDataProps> = ({
  country,
  index,
  filteredPartnerScore,
  allYearQuarters,
  selectedCountries,
  selectedYear,
  selectedQuarter,
  isLoading,
}) => {
  const countryScores = filteredPartnerScore.filter(score => score.country === country.value);

  return (
    <tr
      key={`country-${country.value}`}
      className={`${index % 2 === 0 ? styles.tableRow : styles.tableRowAlternate} ${
        selectedCountries.includes(country.value) ? styles.selectedRow : ''
      }`}
    >
      <td className={styles.tableData}>{country.label}</td>
      {allYearQuarters.flatMap(({ year, quarters }) =>
        quarters.map(quarter => {
          const dataExists = countryScores.some(score => score.year === year && score.quarter === quarter);
          const isSelectedColumn = year === selectedYear && quarter === selectedQuarter;
          const isSelectedYearAll = year === selectedYear && isAllQuarters(selectedQuarter);

          return (
            <td
              key={`data-${country.value}-${year}-q${quarter}`}
              className={cx(styles.tableDataValue, {
                [styles.hasData]: dataExists,
                [styles.selectedColumn]: isSelectedColumn && !isSelectedYearAll,
                [styles.selectedQuarterAllLeft]: isSelectedYearAll && quarter === 1,
                [styles.selectedQuarterAllRight]: isSelectedYearAll && quarter === 4,
              })}
            >
              {isLoading ? (
                <LoadingSpinner hideLoadingMessage />
              ) : dataExists ? (
                <PartnerScoreDataAvailabilityTickIcon />
              ) : (
                '-'
              )}
            </td>
          );
        }),
      )}
    </tr>
  );
};

export default TableData;
